import ReactLinkify from 'react-linkify';

const Linkify = ({ children, ...props }) => {
  const componentDecorator = (href, text, key) => (
    <a href={ href } key={ key } target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  );

  return (
    <ReactLinkify componentDecorator={ componentDecorator } { ...props }>
      {children}
    </ReactLinkify>
  );
};

export default Linkify;